<div class="sidesheet" [id]="sidesheetId" #sidesheetEl>
  <div class="sidesheet__inner">
    <div class="sidesheet__header">
      @if (showBackButton) {
        <a href="#" class="sidesheet__header-back" (click)="onBackClick($event)">
          <svg class="icon">
            <use xlink:href="#arrow-left"></use>
          </svg>
        </a>
      }
      <h5>{{ getBenefitsTitle(data) || title }}</h5>
      @if (showEditButton) {
        <a href="#" class="sidesheet__header-edit" (click)="onEditClick($event)">
          <svg class="icon">
            <use xlink:href="#edit"></use>
          </svg>
        </a>
      }
    </div>

    <div class="sidesheet__body">
      <!-- Benefits type layout -->
      @if (type === 'benefits' && getUniqueClasses(data).length) {
        <!-- Class accordions: each item with its own add-ons and prices (read only) -->
        @for (cls of getUniqueClasses(data); track cls.class_id) {
          <div class="progress-panels__category" [class.collapsed]="!isClassOpen(cls.class_id)"
            [attr.aria-expanded]="isClassOpen(cls.class_id)" (click)="toggleClass(cls.class_id)" style="cursor: pointer;">
            <div class="progress-panels__category-icon">
              <img [src]="classIcon(cls)" class="icon" alt="" (error)="onClassIconError($event)" />
            </div>
            <div class="progress-panels__category-title"><p>{{ cls.class_name }}</p></div>
            <div class="progress-panels__category-caret">
              <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
            </div>
          </div>
          <div class="progress-panels__category-items collapse" [class.show]="isClassOpen(cls.class_id)">
            <div class="progress-panels__benefits">
              @for (entry of getItemsForClass(data, cls.class_id); track entry.item_id) {
                <div class="progress-panels__benefits-wrap">
                  <div class="progress-panels__item">
                    <div class="progress-panels__item-content">
                      <div class="progress-panels__item-title">
                        <strong>{{ getItemTitle(entry.description) }}</strong>
                      </div>
                      <div class="progress-panels__item-cost">
                        <p class="price price--sm"><strong>{{ entry.premium }}</strong> /{{ entry.frequency_short }}</p>
                      </div>
                      @if (getItemSubtitle(entry.description)) {
                        <div class="progress-panels__item-subtitle">
                          <small>{{ getItemSubtitle(entry.description) }}</small>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="progress-panels__benefits-items">
                    @for (b of getItemBenefits(data, cls.class_id, entry.item_id); track b.product_vaps_id) {
                      <div class="progress-panels__benefits-item">
                        <div class="progress-panels__benefits-item-content">
                          <div class="progress-panels__benefits-item-icon">
                            <img [src]="b.img_path" class="icon" alt="" (error)="onIconError($event)" />
                          </div>
                          <div class="progress-panels__benefits-item-title">
                            <p>{{ b.product_vaps_name }}</p>
                          </div>
                          <div class="progress-panels__benefits-item-price">
                            <p class="price price--xs"><strong>{{ b.premium }}</strong>/{{ b.frequency_short || 'mo' }}</p>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
      @if (type === 'benefits' && !getUniqueClasses(data).length) {
        @for (item of getBenefitItems(data); track item) {
          <div class="custom-traffic-edit custom-traffic-edit--sidebar" (click)="onItemClick(item)">
            <div class="custom-traffic-edit__body">
              <div class="custom-traffic-edit__details">
                <div class="custom-traffic-edit__label">
                  @if (item.img_path) {
                    <div class="custom-traffic-edit__icon">
                      <img [src]="item.img_path" alt="" class="icon icon--md" />
                    </div>
                  }
                  <div class="custom-traffic-edit__title">
                    <h6>{{ item.product_vaps_name }}</h6>
                  </div>
                </div>
                @if (item.items) {
                  <ul class="custom-traffic-edit__items list-unstyled">
                    @for (subItem of parseJson(item.items); track $index) {
                      <li><small>{{ subItem.description }}</small></li>
                    }
                  </ul>
                }
              </div>
              @if (item.premium) {
                <div class="custom-traffic-edit__other">
                  <div class="custom-traffic-edit__price">
                    <p class="price price--sm"><strong>{{ item.premium }}</strong>/{{ item.frequency_short || 'mo' }}</p>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }

      <!-- Rating type layout -->
      @if (type === 'rating') {
        <div class="company-ratings">
          <div class="company-ratings__overall mb-20">
            <div class="company-ratings__overall-title">
              <strong>Overall Rating</strong>
            </div>
            <div class="company-ratings__overall-stars">
              <div class="stars">
                @for (starPercent of getStarsArray(); track $index) {
                  <div class="stars__star">
                    <svg class="icon">
                      <use xlink:href="#star-inactive"></use>
                    </svg>
                    <div class="stars__percent" [ngClass]="getStarPercentClass(starPercent)">
                      <svg class="icon">
                        <use xlink:href="#star-active"></use>
                      </svg>
                    </div>
                  </div>
                }
                <div class="stars__label">{{ getStarsLabel() }}</div>
              </div>
            </div>
          </div>
          @if (ratingData?.length) {
            <ul class="company-ratings__list">
              @for (rating of ratingData; track rating.rating_type) {
                <li>
                  <div class="company-ratings__title">
                    <strong>{{ rating.rating_type }}</strong>
                  </div>
                  <div class="company-ratings__score">
                    <strong>{{ rating.rating_score }}/{{ rating.rating_denom }}</strong>
                  </div>
                  @if (rating.rating_tagline) {
                    <div class="company-ratings__comment">
                      <p><small>{{ rating.rating_tagline }}</small></p>
                    </div>
                  }
                </li>
              }
            </ul>
          }
        </div>
      }

      <!-- Excesses type layout: a collapsible block per class, each item with its excess control -->
      @if (type === 'excesses') {
        @for (cls of getUniqueClasses(data); track cls.class_id) {
          <div class="progress-panels__category" [class.collapsed]="!isClassOpen(cls.class_id)"
            [attr.aria-expanded]="isClassOpen(cls.class_id)" (click)="toggleClass(cls.class_id)" style="cursor: pointer;">
            <div class="progress-panels__category-icon">
              <img [src]="classIcon(cls)" class="icon" alt="" (error)="onClassIconError($event)" />
            </div>
            <div class="progress-panels__category-title"><p>{{ cls.class_name }}</p></div>
            <div class="progress-panels__category-caret">
              <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
            </div>
          </div>
          <div class="progress-panels__category-items collapse" [class.show]="isClassOpen(cls.class_id)">
            @for (item of getItemsForClass(data, cls.class_id); track item.item_id) {
              <div class="progress-panels__item">
                <div class="progress-panels__item-content">
                  <div class="progress-panels__item-title">
                    <strong>{{ item.description_1 }}</strong>
                  </div>
                  <div class="progress-panels__item-cost">
                    @if (isItemLoading(item)) {
                      <div class="loading-skeleton-price loading-skeleton-price--sm"></div>
                    } @else {
                      <p class="price price--sm"><strong>{{ item.premium }}</strong> /{{ item.frequency_short }}</p>
                    }
                  </div>
                  @if (item.description_2?.trim()) {
                    <div class="progress-panels__item-subtitle">
                      <small>{{ item.description_2 }}</small>
                    </div>
                  }
                </div>
              </div>
              @if (item.min_excess || item.max_excess) {
                <div class="progress-panels__excess">
                  <div class="form-group" [class.has-error]="hasExcessError(item)">
                    <label class="form-group__label"><strong>Adjust Excess</strong></label>
                    <div class="input-wrap">
                      <input type="text"
                        #excessInput
                        [value]="item.excess"
                        placeholder="Enter excess"
                        inputmode="numeric"
                        class="form-control"
                        [disabled]="isItemLoading(item)"
                        (input)="onExcessInput(item, $event)" />
                      <div class="input-wrap-prepend">
                        <div class="input-wrap-symbol">R</div>
                      </div>
                      @if (hasExcessChanges(item) && !hasExcessError(item)) {
                        <div class="input-wrap-append">
                          <span class="input-wrap-button">
                            <button type="button" data-toggle="apply" class="link link--lg"
                              [disabled]="isItemLoading(item)"
                              (click)="onExcessChange(item, excessInput)">Apply</button>
                          </span>
                        </div>
                      }
                    </div>
                    <div class="custom-input-range__labels">
                      @if (item.min_excess) {
                        <small class="custom-input-range__labels-min">
                          Min: <strong>R{{ item.min_excess }}</strong>
                        </small>
                      }
                      @if (item.recommended_excess) {
                        <small class="custom-input-range__labels-mid">
                          Rec<span class="d-none d-sm-inline">ommended</span>: <strong>R{{ item.recommended_excess }}</strong>
                        </small>
                      }
                      @if (item.max_excess) {
                        <small class="custom-input-range__labels-max">
                          Max: <strong>R{{ item.max_excess }}</strong>
                        </small>
                      }
                    </div>
                    @if (hasExcessError(item)) {
                      <label class="form-control-error">
                        <svg class="icon"><use xlink:href="#warning-filled"></use></svg>
                        Please enter a valid excess amount
                      </label>
                    }
                  </div>
                </div>
              } @else if (item.excess) {
                <div class="progress-panels__excess progress-panels__excess--no-edit">
                  <div class="progress-panels__excess-item">
                    <div class="progress-panels__excess-item-title">Excess</div>
                    <div class="progress-panels__excess-item-price">
                      <p class="price price--sm">{{ formatExcess(item.excess) }}</p>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        }
      }

        <!-- Custom type layout -->
        @if (type === 'custom') {
          <ng-content></ng-content>
        }

        <!-- Help type layout -->
        @if (type === 'help') {
          <div class="sidesheet__help-content">
            @for (item of data; track item) {
              <div class="sidesheet__help-item">
                @if (item.icon) {
                  <div class="sidesheet__help-icon">
                    <img [src]="item.icon" alt="" class="icon icon--lg" />
                  </div>
                }
                <h6>{{ item.title }}</h6>
                @if (item.subtitle) {
                  <p>{{ item.subtitle }}</p>
                }
              </div>
            }
          </div>
        }

        <!-- item form type layout -->
        @if (type === 'item-form') {
          <div class="form-group">
            @for (question of itemQuestions; track question) {
              <app-question-controller [question]="question" [showLabel]="true"
                [showParent]="false" [isEditModal]="true" [readOnly]="false" [showLabelEmailVersion]="true"
                (questionAnswer)="questionResponse($event)" [controlCssClass]="' '">
              </app-question-controller>
            }
          </div>
        }

        <!-- Insured items type layout -->
        @if (type === 'insured-items') {
          @for (cls of getUniqueClasses(data); track cls.class_id) {
            <!-- Class accordion header -->
            <div class="progress-panels__category" [class.collapsed]="!isClassOpen(cls.class_id)"
              [attr.aria-expanded]="isClassOpen(cls.class_id)" (click)="toggleClass(cls.class_id)" style="cursor: pointer;">
              <div class="progress-panels__category-icon">
                <img [src]="classIcon(cls)" class="icon" alt="" (error)="onClassIconError($event)" />
              </div>
              <div class="progress-panels__category-title"><p>{{ cls.class_name }}</p></div>
              <div class="progress-panels__category-caret">
                <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
              </div>
            </div>
            <div class="progress-panels__category-items collapse" [class.show]="isClassOpen(cls.class_id)">
              @for (entry of getItemsForClass(data, cls.class_id); track entry.item_id) {
                <div class="progress-panels__item">
                  <div class="progress-panels__item-content">
                    <div class="progress-panels__item-title">
                      <strong>{{ getItemTitle(entry.description) }}</strong>
                    </div>
                    <div class="progress-panels__item-cost">
                      <p class="price price--sm"><strong>{{ entry.premium }}</strong> /{{ entry.frequency_short }}</p>
                    </div>
                    @if (getItemSubtitle(entry.description)) {
                      <div class="progress-panels__item-subtitle">
                        <small>{{ getItemSubtitle(entry.description) }}</small>
                      </div>
                    }
                  </div>
                  <!-- Benefits (optional, pre-aggregated by getInsuredItems) -->
                  @if (getAggregatedBenefit(entry); as benefit) {
                    <div class="progress-panels__item-extra">
                      <div class="progress-panels__item-extra-icon">
                        <svg class="icon icon--sm">
                          <use xlink:href="#policy-benefits"></use>
                        </svg>
                      </div>
                      <div class="progress-panels__item-extra-title">
                        <small>{{ benefit.benefits_label }}</small>
                        @if (benefit.benefit_names?.length) {
                          <a class="popover-trigger popover-trigger--hover popover-trigger--sm" tabindex="0"
                            data-toggle="popover" data-trigger="focus" data-html="true" data-placement="top"
                            [attr.data-content]="buildNamesPopover(benefit.benefit_names)">
                            <svg class="icon icon--sm"><use xlink:href="#info-solid"></use></svg>
                          </a>
                        }
                      </div>
                      @if (benefit.benefits_premium) {
                        <div class="progress-panels__item-extra-cost">
                          <p class="price price--xs"><strong>{{ benefit.benefits_premium }}</strong> /{{ benefit.frequency_short }}</p>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      </div>

      <!-- Item form tray -->
      @if (type === 'item-form') {
        <div class="sidesheet__tray">
          <div class="sidesheet__tray-btns">
            <a href="javascript:;" class="button button--block button--naked" (click)="onBackClick($event)">Cancel</a>
            <a href="javascript:;" class="button button--block button--primary"
              [class.button--disabled]="!isItemFormValid && editingIndex <= -1"
              (click)="onItemFormSave()">
              {{ editingIndex > -1 ? 'Save' : 'Add' }}
            </a>
          </div>
        </div>
      }

      <!-- Rating type tray -->
      @if (type === 'rating' && showTray) {
        <div class="sidesheet__tray sidesheet__tray--no-bdr">
          <div class="text-color-grey-7 mb-20">
            <h6 class="mb-10">How we calculate ratings</h6>
            <p>This rating is based on whether an insurer is good or not in the areas our customers care about.</p>
          </div>
        </div>
      }

      <!-- Benefits type tray -->
      @if (type === 'benefits' && showTray && getAddonsPremium(data)) {
        <div class="sidesheet__tray">
          <div class="sidesheet__tray-price">
            <p><strong><em>{{ getAddonsPremium(data).premium }}</em></strong>/{{ getAddonsPremium(data).frequency_short || 'mo' }}</p>
          </div>
        </div>
      }

      <!-- Insured items subtotal tray (shown when the data contains a subtotal entry) -->
      @if (type === 'insured-items' && showTray && getSubtotalEntry(data)) {
        <div class="sidesheet__tray p-0">
          <div class="quote-progress__subtotal">
            <div class="quote-progress__subtotal-wrap">
              <div class="quote-progress__subtotal-name">
                <strong>{{ getSubtotalEntry(data).description }}</strong>
                @if (getSubtotalEntry(data).tooltip) {
                  <a
                    class="popover-trigger popover-trigger--hover popover-trigger--sm"
                    tabindex="0"
                    data-toggle="popover"
                    data-trigger="focus"
                    data-html="true"
                    data-placement="top"
                    [attr.data-content]="buildTooltip(getSubtotalEntry(data).tooltip)">
                    <svg class="icon icon--sm">
                      <use xlink:href="#help-Icon"></use>
                    </svg>
                  </a>
                }
              </div>
              <div class="quote-progress__subtotal-cost">
                <p class="price"><strong><em>{{ getSubtotalEntry(data).premium }}</em></strong> /{{ getSubtotalEntry(data).frequency_short }}</p>
              </div>
              @if (getFeeEntries(data).length) {
                <a [href]="'#' + sidesheetId + '-total-breakdown'" class="quote-progress__subtotal-caret"
                  data-toggle="collapse" aria-expanded="true">
                  <svg class="icon"><use xlink:href="#chevron-right"></use></svg>
                </a>
              }
            </div>
            @if (getFeeEntries(data).length) {
              <div class="quote-progress__subtotal-body collapse show" [id]="sidesheetId + '-total-breakdown'">
                <dl class="quote-progress__subtotal-grid">
                  @for (fee of getFeeEntries(data); track fee) {
                    <dt>{{ fee.description }}</dt>
                    <dd>{{ fee.premium }} /{{ fee.frequency_short }}</dd>
                  }
                </dl>
              </div>
            }
          </div>
        </div>
      }

      <!-- Default tray for other types -->
      @if (type !== 'rating' && type !== 'benefits' && showTray && trayTotal && !(type === 'insured-items' && getSubtotalEntry(data))) {
        <div class="sidesheet__tray">
          <div class="sidesheet__tray-price">
            @if (type === 'excesses') {
              <div class="sidesheet__tray-price-label">
                <strong class="font-16">Premium</strong>
              </div>
            }
            @if (loadingItemIds.size > 0) {
              <div class="loading-skeleton-price loading-skeleton-price--lg"></div>
            }
            @if (loadingItemIds.size === 0) {
              <p><strong><em>{{ trayTotal }}</em>.00</strong>/{{ getTrayFrequencyShort() }}</p>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="sidesheet__overlay" (click)="close()"></div>
